/**
 * Returns the appropriate display name for a channel.
 * For LinkedIn channels, uses displayName if available, otherwise falls back to name.
 * For all other channels, uses name if available, otherwise falls back to displayName.
 */
export function getChannelNameForDisplay(channel: {
  service: string
  name: string | null
  displayName?: string | null
}): string {
  if (channel.service === 'linkedin' && channel.displayName) {
    return channel.displayName
  }

  // Fall back to displayName if name is empty or null
  if (!channel.name && channel.displayName) {
    return channel.displayName
  }

  return channel.name ?? ''
}
